// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Iraq from '../_raw/flag/icon_flag_iraq.png';

export default () => <img src={Iraq} alt="Iraq" />;
